import React, { useState } from "react";
import { Form, InputNumber } from "antd";
import { ModalComponent, ButtonComponent } from "@comps/components";

const formName = "addIprsForm";

/**
 * Size an interproximal reduction, and say which aligner it happens
 * before.
 *
 * Wears the same shell as every other dialog in the app - it was a raw
 * antd Modal with its labels beside the inputs, so it arrived without the
 * icon chip, the subtitle and the title face the rest of them have.
 */
const AddIprsComponent = (props) => {

  const [iprData, setIprData] = useState(props.initialData ? props.initialData.mm : 0);
  const [stepData, setStepData] = useState(props.initialData ? props.initialData.afterStep : 0);

  const onSaveData = () => {
    props.setIprs((prevIprs) => {
      // Check if an object with the same index and stepIndex exists
      const existingIndex = prevIprs.findIndex(
        (attachment) =>
          attachment.index === props.index && attachment.stepIndex === props.stepIndex
      );

      if (existingIndex !== -1) {
        // Replace the action of the existing object
        const updatedAttachments = [...prevIprs];
        updatedAttachments[existingIndex].mm = iprData;
        updatedAttachments[existingIndex].afterStep = stepData;
        return updatedAttachments;
      } else {
        // Add a new object if it doesn't exist
        return [
          ...prevIprs,
          {
            mm: iprData,
            afterStep: stepData,
            index: props.index,
            stepIndex: props.stepIndex,
          },
        ];
      }
    });
    props.handleCancel();
  };

  // "Clear" drops the IPR from this gap altogether rather than storing a
  // zero - a 0 mm IPR would still draw a filled triangle on the diagram
  // and still take a row in the summary table.
  const onClearData = () => {
    props.setIprs((prevIprs) => prevIprs.filter(
      (each) => !(each.index === props.index && each.stepIndex === props.stepIndex)
    ));
    props.handleCancel();
  };

  const footer = (
    <div className="form-actions">
      <ButtonComponent key="clear" danger ghost onClick={ onClearData }>
        Clear
      </ButtonComponent>
      <ButtonComponent key="submit" form={ formName } htmlType="submit" type="primary">
        Save IPR
      </ButtonComponent>
    </div>
  );

  return (
    <ModalComponent
      icon="tabler:arrows-horizontal"
      mainTitle="Size of IPR"
      subTitle={ props.teeth ? `Between teeth ${ props.teeth }` : "Enter the reduction for this gap" }
      open={ true }
      onCancel={ props.handleCancel }
      width="min(420px, calc(100vw - 32px))"
      footer={ footer }
    >
      <Form layout="vertical" name={ formName } onFinish={ onSaveData }>
        <Form.Item label="Reduction" className="da-mb-16">
          <InputNumber
            min={ 0 }
            step={ 0.1 }
            addonAfter="mm"
            style={ { width: '100%' } }
            onChange={ (value) => setIprData(value) }
            value={ iprData }
          />
        </Form.Item>
        <Form.Item label="Before aligner" className="da-mb-0">
          <InputNumber
            min={ 0 }
            step={ 1 }
            style={ { width: '100%' } }
            onChange={ (value) => setStepData(value) }
            value={ stepData }
          />
        </Form.Item>
      </Form>
    </ModalComponent>
  );
};

export default AddIprsComponent;
